import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-check-out',
	templateUrl: './icon-check-out.component.svg',
})
export class IconCheckOutComponent {}
